import type { ColorItemActionsProps } from '@components/ArtBoard/ColorLibrary'
import {
  DndContext,
  type DragEndEvent,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import { SortableContext, sortableKeyboardCoordinates } from '@dnd-kit/sortable'
import type { ColorItem as ColorItemType } from '@octopus-do/octopus-project-core'
import type React from 'react'

import { ColorItem } from '../ColorItem'

interface Props extends ColorItemActionsProps {
  colors?: ColorItemType[]
  onMoveColor: (id: string, index: number) => void
}

export const ColorList: React.FC<Props> = ({
  colors,
  onMoveColor,
  ...rest
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    if (over && active.id !== over.id) {
      if (!colors) {
        return null
      }

      const activeIndex = colors.findIndex(({ id }) => id === active.id)
      const overIndex = colors.findIndex(({ id }) => id === over.id)

      onMoveColor(colors[activeIndex].id, overIndex)
    }
  }

  return (
    <DndContext sensors={sensors} onDragEnd={handleDragEnd}>
      <SortableContext items={colors || []}>
        <>
          {colors?.map((color) => (
            <ColorItem key={color.id} id={color.id} {...rest} />
          ))}
        </>
      </SortableContext>
    </DndContext>
  )
}
